export default "__VITE_ASSET__PfO$d_ma__"